// Module
var code = `<div appHeaderBar>
    <header-bar-title>Property Group Details</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <app-cobrand-header [property]="staticPropertyGroupNickname"
                        [manager]="staticPmcName"
                        [association]="staticPmcCouponId">
    </app-cobrand-header>

    <form *ngIf="doneLoading" name="Form" id="Form" class="form" #form="ngForm">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <h1 class="HOA-container__header-text" id="propertyDetailsHeader">
                    Related Accounts Group
                </h1>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-splash-copy
                                    HOA-propertyblock-flextable__cell
                                    HOA-propertyblock-flextable__cell--100">
                    Group of multiple accounts for the same address, each of which require separate payments.
                    <br><br>Use ‘Register’ to register new account(s) and add them to the group.
                    <br>Use 'Add' to add existing registered account(s) to the group.
                    <br>Use 'Remove' to take accounts out of the group.
                    <br><br>Note you will need to set up separate payments for each account from
                    the Properties page.
                </div>
                <div [ngClass]="{ 'is-invalid': propertyGroupNicknameError }"
                     class="Field HOA-card-flex-child-100 HOA-card-flex-offset-child-left">
                    <label for="propertyGroupNickname" class="Field-label" id="nicknameHeader">
                        Group Nickname
                        <span class="asterisk-required">&nbsp;&#42;</span>
                        <div style="float: right">
                            <button type="button"
                                    class="HOA-flex-center-info-button"
                                    style="padding: 0;margin-left: 5px"
                                    (click)="groupNameHelper()"
                                    id="groupNameHelper()">
                                            <span class="Icon
                                                        Icon--18
                                                        icon-utility-basics-question_circle-18
                                                        u-iconBlue background-image-none">
                                                <svg focusable="false"
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     width="18"
                                                     height="18"
                                                     viewBox="0 0 72 72">
                                                    <title>Group Nickname</title>
                                                    <path class="stroke_layer"
                                                          d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="fill_layer"
                                                          d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                          fill="#838383"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="stroke_layer"
                                                          data-name="stroke_layer"
                                                          d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8
                                                            8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1
                                                            1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5
                                                            0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7
                                                            1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3
                                                            0 0 0-.1 1.7v2.6"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                </svg>
                                            </span>
                            </button>
                        </div>
                    </label>

                    <input type="text"
                           class="Input"
                           id="propertyGroupNickname"
                           name="propertyGroupNickname"
                           [(ngModel)]="nickname"
                           (change)="propertyGroupNickname()"
                           aria-invalid="propertyGroupNicknameError"
                           attr.aria-describedby="{{propertyGroupNicknameError && 'propertyGroupNickname-error' || undefined }}"
                           maxlength="100">
                    <span class="Field-error" id="propertyNickname-error">
                                Please enter a group nickname.
                            </span>
                </div>
                <div class="HOA-Checking-Detail-button-container">
                    <button name="submitSave"
                            id="submitSave"
                            type="submit"
                            class="Button Button--blue"
                            [disabled]="invalid()"
                            (click)="rename()">
                        <span id="saveLabel">Save</span>
                    </button>
                </div>

                <div class="HOA-propertyblock-flextable">
                    <!-- PSEUDO ROW -->
                    <div class="HOA-flextable-component__subheader
                                        HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--100">
                        Related Accounts
                    </div>
                    <!-- PSEUDO ROW -->
                    <div class="HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--list
                                        HOA-propertyblock-flextable__cell--25
                                        HOA-propertyblock-flextable--truncate">
                        <div class="HOA-propertyblock-flextable__cell-label
                                            HOA-propertyblock-flextable--truncate">
                            Account # <br> Association ID
                        </div>
                    </div>
                    <div class="HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--list
                                        HOA-propertyblock-flextable__cell--50
                                        HOA-propertyblock-flextable--truncate">
                        <div class="HOA-propertyblock-flextable__cell-label
                                            HOA-propertyblock-flextable--truncate">
                            Property Nick Name <br> Association Name
                        </div>
                    </div>
                    <div class="HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--list
                                        HOA-propertyblock-flextable__cell--25">
                        <div class="HOA-propertyblock-flextable__cell-label u-margin-right-align"></div>
                    </div>

                    <ng-container *ngFor="let member of sortedGroupMembers">
                        <div class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--25
                                            HOA-propertyblock-flextable--truncate">
                            <div class="HOA-propertyblock-flextable__cell-value
                                                HOA-propertyblock-flextable--truncate
                                                HOA-propertyblock-flextable--truncate-addMarginOnFocus">
                                {{member.couponId}} <br>
                                {{member.hoa.couponId}}
                            </div>
                        </div>

                        <div class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--50
                                            HOA-propertyblock-flextable--truncate">
                            <div class="HOA-propertyblock-flextable__cell-value
                                                HOA-propertyblock-flextable--truncate">
                                {{member.nickname}} <br>
                                <span style="text-transform:capitalize">{{member.hoa.name.toLowerCase()}}</span>
                            </div>
                        </div>
                        <div class="HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--25">
                            <div class="HOA-propertyblock-flextable__cell-value
                                                HOA-Checking-Detail-button-container">
                                <button name="removeProperty"
                                        id="removeProperty"
                                        type="button"
                                        class="Button Button--blue "
                                        style="margin-left: 5px"
                                        (click)="removeProperty(member.id)">
                                    Remove
                                </button>
                                <button type="button"
                                        class="HOA-flex-center-info-button"
                                        style="padding: 0;margin-left: 5px"
                                        (click)="removePropertyHelper()"
                                        id="removePropertyHelper">
                                            <span class="Icon
                                                        Icon--18
                                                        icon-utility-basics-question_circle-18
                                                        u-iconBlue
                                                        background-image-none">
                                                <svg focusable="false"
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     width="18"
                                                     height="18"
                                                     viewBox="0 0 72 72">
                                                    <title>Remove Account</title>
                                                    <path class="stroke_layer"
                                                          d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="fill_layer"
                                                          d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                          fill="#838383"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="stroke_layer"
                                                          data-name="stroke_layer"
                                                          d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0
                                                            0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0
                                                            1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5
                                                            1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8
                                                            12.3 12.3 0 0 0-.1 1.7v2.6"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                </svg>
                                            </span>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                    <!-- NG-REPEAT END-->

                    <!-- PSEUDO ROW -->
                    <div class="HOA-container__content-hrule
                                        HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--100 u-mT5">
                    </div>
                    <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"
                         class="HOA-flextable-component__subheader
                                        HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--100">
                        Available Accounts
                    </div>
                    <!-- PSEUDO ROW -->
                    <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"
                         class="HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--list
                                        HOA-propertyblock-flextable__cell--25
                                        HOA-propertyblock-flextable--truncate">
                        <div class="HOA-propertyblock-flextable__cell-label
                                            HOA-propertyblock-flextable--truncate">
                            Account # <br> Association ID
                        </div>
                    </div>
                    <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"
                         class="HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--list
                                        HOA-propertyblock-flextable__cell--50
                                        HOA-propertyblock-flextable--truncate">
                        <div class="HOA-propertyblock-flextable__cell-label
                                            HOA-propertyblock-flextable--truncate">
                            Property Nick Name <br> Association Name
                        </div>
                    </div>
                    <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"
                         class="HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--list
                                        HOA-propertyblock-flextable__cell--25">
                        <div class="HOA-propertyblock-flextable__cell-label u-margin-right-align"></div>
                    </div>

                    <!-- NG-REPEAT START: GROUP CANDIDATES -->
                    <!-- PSEUDO ROW -->
                    <ng-container *ngFor="let candidate of sortedGroupCandidates">
                        <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"
                             class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--25
                                            HOA-propertyblock-flextable--truncate">
                            <div class="HOA-propertyblock-flextable__cell-value
                                                HOA-propertyblock-flextable--truncate
                                                HOA-propertyblock-flextable--truncate-addMarginOnFocus">
                                {{candidate.couponData.propertyCouponId}} <br>
                                {{candidate.couponData.hoaCouponId}}
                            </div>
                        </div>
                        <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"
                             class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--50
                                            HOA-propertyblock-flextable--truncate">
                            <div class="HOA-propertyblock-flextable__cell-value
                                                HOA-propertyblock-flextable--truncate">
                                {{candidate.nickname}} <br>
                                {{candidate.hoaName}}
                            </div>
                        </div>
                        <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"
                             class="HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--25"
                             [ngSwitch]="candidate.propertyId > 0">
                            <div class="HOA-propertyblock-flextable__cell-value HOA-Checking-Detail-button-container">
                                <button *ngSwitchCase="true"
                                        name="addProperty"
                                        id="addProperty"
                                        type="button"
                                        class="Button Button--blue"
                                        style="margin-left: 5px"
                                        (click)="addProperty(candidate.propertyId)">
                                    Add
                                </button>
                                <button *ngSwitchCase="true"
                                        type="button"
                                        id="addPropertyHelperButton"
                                        class="HOA-flex-center-info-button"
                                        style="padding: 0;margin-left: 5px"
                                        (click)="addPropertyHelper()" >
                                            <span class="Icon
                                                        Icon--18
                                                        icon-utility-basics-question_circle-18
                                                        u-iconBlue
                                                        background-image-none">
                                                <svg focusable="false"
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     width="18"
                                                     height="18"
                                                     viewBox="0 0 72 72">
                                                    <title>Add Account</title>
                                                    <path class="stroke_layer"
                                                          d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="fill_layer"
                                                          d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                          fill="#838383"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="stroke_layer"
                                                          data-name="stroke_layer"
                                                          d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0
                                                            0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0
                                                            1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5
                                                            1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8
                                                            12.3 12.3 0 0 0-.1 1.7v2.6"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                </svg>
                                            </span>
                                </button>
                                <button *ngSwitchCase="false"
                                        name="registerProperty"
                                        id="registerProperty"
                                        type="button"
                                        class="Button Button--blue"
                                        style="margin-left: 5px"
                                        (click)="register(candidate)">
                                    Register
                                </button>
                                <button *ngSwitchCase="false"
                                        type="button"
                                        class="HOA-flex-center-info-button"
                                        style="padding: 0;margin-left: 5px"
                                        (click)="registerPropertyHelper()"
                                        id="addPropertyHelper">
                                            <span class="Icon
                                                        Icon--18
                                                        icon-utility-basics-question_circle-18
                                                        u-iconBlue
                                                        background-image-none">
                                                <svg focusable="false"
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     width="18"
                                                     height="18"
                                                     viewBox="0 0 72 72">
                                                    <title>Register Account</title>
                                                    <path class="stroke_layer"
                                                          d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="fill_layer"
                                                          d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                          fill="#838383"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="stroke_layer"
                                                          data-name="stroke_layer"
                                                          d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8
                                                            8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1
                                                            1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5
                                                            0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7
                                                            1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0
                                                            0 0-.1 1.7v2.6"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                </svg>
                                            </span>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"></div>
                    </ng-container>
                    <!-- NG-REPEAT END-->
                    <div *ngIf="groupCandidates !== undefined && groupCandidates.length > 0"
                         class="HOA-container__content-hrule
                                        HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--100 u-mT5">
                    </div>

                </div>

                <div class="HOA-Checking-Detail-button-container">
                    <button name="cancel"
                            id="cancel"
                            type="button"
                            class="Button Button--link"
                            (click)="cancel()">
                        Close
                    </button>
                </div>
                <div class="u-pT2
                                    HOA-flex-component
                                    HOA-font-fine-print"
                     id="finePrint">
                    <span class="asterisk-required">&#42;</span>
                    &nbsp;Indicates required field
                </div>
            </div>
        </div>
    </form>
</app-page-content>`;
// Exports
module.exports = code;